module.exports = __webpack_public_path__ + "img/camper-purple.63505de9.svg";